export const FETCH_WALLET_DETAILS = "FETCH_WALLET_DETAILS"
export const CLEAR_WALLET_DETAILS = "CLEAR_WALLET_DETAILS"